
export const apiURL = process.env.API_URL
export const version = process.env.VERSION
export const authTokenStorageKEY = 'APP_AUTH_TOKEN'



// WEBPACK FOOTER //
// ./src/config.js